import { Component, HostListener, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-crear-usuario',
  templateUrl: './crear-usuario.component.html',
  styleUrls: ['./crear-usuario.component.scss']
})
export class CrearUsuarioComponent implements OnInit {
  public mensajeError: string = '';
  public mostrarPassword: boolean = false;
  public mostrarPasswordConfirm: boolean = false;
  public emailControl = new FormControl('', [Validators.required, Validators.email]);
  public passwordConfirmControl = new FormControl('', [Validators.required]);
  public passwordControl = new FormControl('', [
    Validators.required,
    Validators.minLength(6),
    Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).+$/)
  ]);
  public bloqMayusActivado: boolean = false;

  constructor(
    private readonly _router: Router,
  ) {}

  public crearUsuario() {
    const email = this.emailControl.value;
    const password = this.passwordControl.value;
    const passwordConfirm = this.passwordConfirmControl.value;

    const usuarios = [
      { email: 'axel@asesorcontable.mx', password: 'Password123' },
      { email: 'carlos@asesorcontable.mx', password: 'Test456' }
    ];

    if (!email) {
      this.emailControl.setErrors({ emailError: true });
      this.mensajeError = 'Debe ingresar un correo';
      return;
    }

    if (this.emailControl.invalid) {
      this.emailControl.setErrors({ emailError: true });
      this.mensajeError = 'El formato del correo no es valido';
      return;
    }

    if (!password || !passwordConfirm) {
      this.passwordControl.setErrors({ passwordError: true });
      this.mensajeError = 'Debe ingresar una contraseña';
      return;
    }

    if (this.passwordControl.hasError('minlength')) {
      this.mensajeError = 'La contraseña debe tener al menos 6 caracteres';
      return;
    }

    if (this.passwordControl.hasError('pattern')) {
      this.mensajeError = 'La contraseña debe incluir una mayúscula, una minúscula, un número y un carácter especial (e.g. !@#$%^&*)';
      return;
    }

    if (password !== passwordConfirm) {
      this.passwordControl.setErrors({ passwordError: true });
      this.passwordConfirmControl.setErrors({ passwordError: true });
      this.mensajeError = 'Las contraseñas no coinciden';
      return;
    }

    const usuarioExistente = usuarios.find(u => u.email === email);
    if (usuarioExistente) {
      this.emailControl.setErrors({ emailError: true });
      this.mensajeError = 'El correo que intenta registrar ya existe';
      return;
    }
  }

  public iniciarSesion() {
    this._router.navigate([`iniciar-sesion`]);
  }

  @HostListener('window:keydown', ['$event'])
  @HostListener('window:keyup', ['$event'])
  public detectarBloqMayusGlobal(event: KeyboardEvent): void {
    this.bloqMayusActivado = event.getModifierState('CapsLock');
  }

  ngOnInit(): void {
  }
}
